module.exports = __webpack_public_path__ + "static/DOGE-d7242520e02b027c00e0e8d163ccaa23.svg";